import * as React from 'react';
import { CartSubmitButton as SharedCartSubmitButton } from '~shared/segments/Cart';
import { useWaiterRouter } from '../../Routing/client';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Button to submit the cart and proceed to the next step of the order.
 * Encapsulated a cart validation & isLoading logic.
 * If `onBackClick` is defined the ButtonWithBack is rendered instead of the regular button.
 */
export var CartSubmitButton = function CartSubmitButton(_ref) {
  var onBackClick = _ref.onBackClick;
  var router = useWaiterRouter();
  var proceedToOrderForm = React.useCallback(function () {
    // TODO validate cart Q (once we have it)
    router.push('form');
  }, [router]);
  return /*#__PURE__*/_jsx(SharedCartSubmitButton, {
    canSubmitOrder: true,
    onBackClick: onBackClick,
    onSubmit: proceedToOrderForm
  });
};